module.exports = __webpack_public_path__ + "static/img/img2.aa4022f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img2.png
// module id = YAwl
// module chunks = 1